import { View, Text, Image, TouchableOpacity, TextInput } from "react-native";
import React, { useState, useEffect } from "react";
import {
  danger,
  femaleColor,
  gray,
  lightBlue,
  maleColor,
  orange,
  primary,
  white,
} from "../../../colors";
import MyText from "../../custom/MyText";
import { doctorAvatar, width } from "../../../imports";
import detailConsultationUser from "../../../api/consultation/detailConsultationUser";
import childConsultationStatus from "../../../api/consultation/childConsultationStatus";
import { useNavigation } from "@react-navigation/native";
import MyButton from "../../custom/MyButton";
import closeConsultation from "../../../api/consultation/closeConsultation";
import { AntDesign } from "@expo/vector-icons";
import tagRating from "../../../api/consultation/tagRating";
import translate from "../../../functions/translate";
import addRating from "../../../api/consultation/addRating";

export default function RateDoctor({ gender, image, children, setId, id }) {
  const navigation = useNavigation();
  const [doctorDetails, setDoctorDetails] = useState({});
  const [haveChat, setHaveChat] = useState(true);
  const [stars, setStars] = useState(0);
  const [rateTagList, setRateTagList] = useState({
    strengths: [],
    weaknesses: [],
  });
  const [selectedStrengths, setSelectedStrengths] = useState([]);
  const [selectedWeaknesses, setSelectedWeaknesses] = useState([]);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (children.id !== undefined) {
      detailConsultationUser(id)
        .then(({ data }) => {
          if (data.status === 200) {
            setDoctorDetails(data.data.doctor);
          }
        })
        .catch((err) => {});
    }
  }, [children]);
  useEffect(() => {
    tagRating().then(({ data }) => {
      if (data.status === 200) {
        setRateTagList(data.data);
      }
    });
  }, []);

  const submitRate = () => {
    addRating(
      id,
      stars,
      [...selectedStrengths, ...selectedWeaknesses].join(","),
      description
    ).then(({ data }) => {
      if (data.status === 200) {
        navigation.pop(1);
      }
    });
  };

  return haveChat ? (
    <View
      style={{
        width: "100%",

        padding: 10,

        marginTop: 0,

        alignItems: "center",
      }}
    >
      <View
        style={{
          width: width / 3,
          height: width / 3,
          borderWidth: 1,
          borderColor: primary,
          borderRadius: width / 3,
          overflow: "hidden",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Image
          source={{ uri: doctorDetails.picUrl }}
          defaultSource={doctorAvatar}
          style={{ width: width / 3 - 10, height: width / 3 - 10 }}
          resizeMode="contain"
        />
      </View>

      <View style={{ marginTop: 10, alignItems: "center" }}>
        <MyText fontFamily={"vazir"} style={{ fontSize: 24 }}>
          {`${doctorDetails.name || ""} ${doctorDetails.lastName || ""}`}
        </MyText>
        <MyText fontFamily={"vazir"} style={{ color: gray, fontSize: 18 }}>{`${
          doctorDetails.decExpertise || ""
        }`}</MyText>
      </View>

      <View style={{ marginTop: 20, alignItems: "center" }}>
        <MyText fontFamily={"vazir"} style={{ fontSize: 26 }}>
          لطفاً امتیاز دهید
        </MyText>
      </View>

      <View
        style={{
          flexDirection: "row-reverse",
          alignItems: "center",
          marginTop: 20,
          padding: 10,
          paddingHorizontal: 30,
          justifyContent: "center",
          alignItems: "center",
          borderWidth: 1,
          borderRadius: 30,
          borderColor: lightBlue,
        }}
      >
        <TouchableOpacity
          onPress={() => setStars(1)}
          style={{ marginHorizontal: 3 }}
        >
          {stars >= 1 ? (
            <AntDesign name="star" size={40} color={orange} />
          ) : (
            <AntDesign name="staro" size={40} color={orange} />
          )}
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => setStars(2)}
          style={{ marginHorizontal: 3 }}
        >
          {stars >= 2 ? (
            <AntDesign name="star" size={40} color={orange} />
          ) : (
            <AntDesign name="staro" size={40} color={orange} />
          )}
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => setStars(3)}
          style={{ marginHorizontal: 3 }}
        >
          {stars >= 3 ? (
            <AntDesign name="star" size={40} color={orange} />
          ) : (
            <AntDesign name="staro" size={40} color={orange} />
          )}
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => setStars(4)}
          style={{ marginHorizontal: 3 }}
        >
          {stars >= 4 ? (
            <AntDesign name="star" size={40} color={orange} />
          ) : (
            <AntDesign name="staro" size={40} color={orange} />
          )}
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => setStars(5)}
          style={{ marginHorizontal: 3 }}
        >
          {stars >= 5 ? (
            <AntDesign name="star" size={40} color={orange} />
          ) : (
            <AntDesign name="staro" size={40} color={orange} />
          )}
        </TouchableOpacity>
      </View>
      <View
        style={{
          width: "99%",
          alignItems: "center",
          padding: 5,
          borderRadius: 10,
          backgroundColor: primary,
          marginTop: 40,

          borderColor: primary,
          borderWidth: 1,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        <MyText
          fontFamily={"vazir"}
          style={{
            fontSize: 20,

            color: "white",
          }}
        >
          {translate("strengths")}
        </MyText>
      </View>
      <View
        style={{
          marginTop: -10,
          flexDirection: "row",
          justifyContent: "center",
          flexWrap: "wrap",
          borderRadius: 5,
          borderColor: primary,
          borderWidth: 1,
          width: "99%",
          padding: 6,
          paddingTop: 20,
          paddingBottom: 10,
        }}
      >
        {rateTagList.strengths.map((item, index) => (
          <TouchableOpacity
            key={index}
            onPress={() =>
              setSelectedStrengths((prev) =>
                selectedStrengths.indexOf(item.nameEn) > -1
                  ? [...prev.filter((a) => a !== item.nameEn)]
                  : [...prev, item.nameEn]
              )
            }
            style={{
              borderRadius: 7,
              borderWidth: 1,
              overflow: "hidden",
              borderColor: primary,
              backgroundColor:
                selectedStrengths.indexOf(item.nameEn) > -1 ? primary : white,
              padding: 10,
              paddingHorizontal: 10,
              marginVertical: 5,
              marginHorizontal: 5,
            }}
          >
            <MyText
              fontFamily={"vazir"}
              style={{
                color:
                  selectedStrengths.indexOf(item.nameEn) > -1 ? white : primary,
              }}
            >
              {item.name}
            </MyText>
          </TouchableOpacity>
        ))}
      </View>
      <View
        style={{
          width: "99%",
          alignItems: "center",
          padding: 5,
          borderRadius: 10,
          backgroundColor: danger,
          marginTop: 30,

          borderColor: danger,
          borderWidth: 1,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        <MyText
          fontFamily={"vazir"}
          style={{
            fontSize: 20,

            color: "white",
          }}
        >
          {translate("weaknesses")}
        </MyText>
      </View>
      <View
        style={{
          marginTop: -10,
          flexDirection: "row",
          justifyContent: "center",
          flexWrap: "wrap",
          borderRadius: 5,
          borderColor: danger,
          borderWidth: 1,
          width: "99%",
          padding: 6,
          paddingTop: 20,
          paddingBottom: 10,
        }}
      >
        {rateTagList.weaknesses.map((item, index) => (
          <TouchableOpacity
            key={index}
            onPress={() =>
              setSelectedWeaknesses((prev) =>
                selectedWeaknesses.indexOf(item.nameEn) > -1
                  ? [...prev.filter((a) => a !== item.nameEn)]
                  : [...prev, item.nameEn]
              )
            }
            style={{
              borderRadius: 7,
              borderWidth: 1,
              overflow: "hidden",
              borderColor: danger,
              backgroundColor:
                selectedWeaknesses.indexOf(item.nameEn) > -1 ? danger : white,
              padding: 10,
              paddingHorizontal: 10,
              marginVertical: 5,
              marginHorizontal: 5,
            }}
          >
            <MyText
              fontFamily={"vazir"}
              style={{
                color:
                  selectedWeaknesses.indexOf(item.nameEn) > -1 ? white : danger,
              }}
            >
              {item.name}
            </MyText>
          </TouchableOpacity>
        ))}
      </View>
      <MyText
        fontFamily={"vazir"}
        style={{
          fontSize: 20,

          marginTop: 25,
          marginBottom: 10,
        }}
      >
        {translate("description")}
      </MyText>

      <TextInput
        fontFamily={"vazir"}
        Input
        onChangeText={(text) => setDescription(text)}
        multiline
        style={{
          borderWidth: 1,
          borderColor: primary,
          borderRadius: 8,
          padding: 10,
          height: 140,
          width: "90%",
          textAlignVertical: "top",
        }}
      />

      {stars === 0 && (
        <View style={{ marginTop: 10, alignItems: "center" }}>
          <MyText fontFamily={"vazir"} style={{ color: danger, fontSize: 18 }}>
            ابتدا باید با استفاده از ستاره ها به مشاوره امتیاز دهید
          </MyText>
        </View>
      )}
      <MyButton
        onPress={stars === 0 ? null : submitRate}
        activeOpacity={stars == 0 ? 1 : 0}
        text={translate("submit rate")}
        style={{
          backgroundColor: orange,
          marginTop: 20,
          width: "70%",
          opacity: stars == 0 ? 0.5 : 1,
        }}
      />
    </View>
  ) : (
    <View
      style={{
        width: "92%",
        marginHorizontal: 5,
        borderRadius: 15,
        borderColor: gender === "female" ? femaleColor : maleColor,
        borderWidth: 1,
        padding: 10,
        backgroundColor: "#F9F9F9",
        marginTop: -10,
        flexDirection: "row",
        alignItems: "center",
      }}
    ></View>
  );
}
